module.exports = __webpack_public_path__ + "static/media/mtnIcon.b17a2819.svg";